export default "__VITE_ASSET__CKayTQQS__"